import { Component } from '@angular/core';
import {CurrentEditionComponent} from "../current-edition/current-edition.component";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {LazyLoadingComponent} from "../../../shared/component/lazy-loading/lazy-loading.component";
import {TranslocoDirective} from "@ngneat/transloco";
import {RouterLink} from "@angular/router";
import {ImageComponent} from "../../../shared/component/image/image.component";
import {DEFAULT_DATE_FORMAT} from "../../../shared/model/constatnt";
import {IssueTemplateComponent} from "../../../shared/component/issue-template/issue-template.component";

@Component({
  selector: 'app-current-edition-card-desktop',
  standalone: true,
  imports: [
    DatePipe,
    LazyLoadingComponent,
    NgForOf,
    NgIf,
    TranslocoDirective,
    RouterLink,
    ImageComponent,
    IssueTemplateComponent
  ],
  templateUrl: './current-edition-card-desktop.component.html',
  styleUrl: './current-edition-card-desktop.component.scss'
})
export class CurrentEditionCardDesktopComponent extends CurrentEditionComponent{

  protected readonly DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
}
